module.exports = __webpack_public_path__ + "img/band.0dea8e8e.jpg";